module.exports = __webpack_public_path__ + "img/f-red.b53a4c60.png";